export default __webpack_public_path__ + "93ee5386334f446901d69e54c06d85ab.svg";